// extracted by mini-css-extract-plugin
export default {"outerWrapper":"styles_outerWrapper__uc6fn","wrapper":"styles_wrapper__A5dYS","hover":"styles_hover__bUMSF"};